module.exports = __webpack_public_path__ + "assets/img/warrior-name-bd758aca.png";